var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.03 18.806"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "streamline-icon-filter-mail@140x140",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27",
    d: "M11.125 9.15a.27.27 0 00.292 0l10.334-6.895a.537.537 0 00.228-.558 2.149 2.149 0 00-2.1-1.7H2.149A2.149 2.149 0 00.032 1.768a.537.537 0 00.243.548z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28",
    d: "M12.311 10.489a1.881 1.881 0 01-2.042.026L.824 4.555A.537.537 0 000 5.01v11.645a2.149 2.149 0 002.149 2.149h17.734a2.149 2.149 0 002.147-2.149V5.014a.537.537 0 00-.835-.447z"
  }))));
}

export default __webpack_public_path__ + "3a39d8f8398067a392e9837dae362323.svg";
export { SvgEmail as ReactComponent };